// extracted by mini-css-extract-plugin
export default {"header__title":"Header_header__title__AVN2F"};